export const handleClose = (setAlertOpen) => {
    setAlertOpen(false)
    return false
}
export default handleClose